import { useEffect } from "react";

import { useRouteModalsStore } from "../route-modals.store";
import { useRouteModalHistoryState } from "./use-modal-history-states";

export const useRouteModalHistoryUpdates = () => {
  const [historyState] = useRouteModalHistoryState();

  const modalState = useRouteModalsStore((state) => state.state);
  const setModalState = useRouteModalsStore((state) => state.setState);

  useEffect(() => {
    if (historyState.state === modalState || modalState) {
      return;
    }

    setModalState(modalState ?? historyState.state);
  }, [historyState, modalState, setModalState]);
};
